// extracted by mini-css-extract-plugin
export default {"icon":"SearchBar_icon__EfDZn","input":"SearchBar_input__bIy50"};